<div class="condition-wrapper">
	<div class="condition-variable" (click)="deleteConditionVariable()">
		<span>{{ conditionVariable.name }}</span>
		<div>
			<i class="fa fa-trash"></i>
		</div>
	</div>
	<div class="condition-content">
		<div class="condition-entity-selector condition-row" *ngIf="conditionVariable.entityType === 'widget'">
			<ie-form-field [label]="'WIDGET' | translate">
				<!-- todo: unique name -->
				<bb-entity-selector 
					[(ngModel)]="conditionVariable.entityId"
					(ngModelChange)="onContentChange($event)"
					[name]="widgetSelector"
					[options]="selectorOptions?.widget"
					theme="dark"
				></bb-entity-selector>
			</ie-form-field>
		</div>
		<ng-container *ngIf="(conditionVariable.entityType === 'widget' && conditionVariable?.rule?.lvalue === 'visible')">
			<bb-radio-list class="condition-row" [options]="radioOptions" [(ngModel)]="conditionVariable.rule.operator" (ngModelChange)="onRadioChange($event)"></bb-radio-list>
		</ng-container>
		<ng-container *ngIf="conditionVariable.entityType !== 'widget' || conditionVariable?.rule?.lvalue !== 'visible'">
			<div class="condition-left condition-row">
				<ie-form-field [label]="'PROPERTY' | translate" *ngIf="conditionVariable.entityType === 'widget'">
					<!-- todo: unique name -->
					<bb-entity-selector 
						[(ngModel)]="conditionVariable.rule.lvalue"
						(ngModelChange)="onContentChange($event)"
						[name]="'widgetSelector'"
						[options]="selectorOptions?.widgetProperties"
						theme="dark"
					></bb-entity-selector>
				</ie-form-field>

				<ie-form-field [label]="'PLAYER' | translate" *ngIf="conditionVariable.entityType === 'player'">
					<!-- todo: unique name -->
					<bb-entity-selector 
						[(ngModel)]="conditionVariable.rule.lvalue"
						(ngModelChange)="setOptions('player');onContentChange($event);"
						[name]="'playerStateSelector'"
						[options]="selectorOptions?.player"
						theme="dark"
					></bb-entity-selector>
				</ie-form-field>

				<ie-form-field [label]="'LOCALSTORAGE' | translate" *ngIf="conditionVariable.entityType === 'localstorage'">
					<!-- todo: unique name -->
					<bb-entity-selector 
						[(ngModel)]="conditionVariable.rule.lvalue"
						(ngModelChange)="onContentChange($event)"
						[name]="'localstorageSelector'"
						[options]="selectorOptions?.localstorage"
						[extendable]="true"
						theme="dark"
					></bb-entity-selector>
				</ie-form-field>

				<ie-form-field
					*ngIf="conditionVariable.entityType === 'compare'"
					[label]="'VALUE' | translate"
					[useDataSource]="true"
					(dataSourceClicked)="dataSourceService.onDataSourceClicked(conditionVariable.rule, dataSourceTemplateLValue)"
					[dataSourceActive]="conditionVariable.rule.lvalue?.datasource"
				>
					<!-- todo: unique name -->
					<bb-entity-selector 
						*ngIf="conditionVariable.rule.lvalue?.datasource?.sourceType"
						[(ngModel)]="conditionVariable.rule.lvalue.datasource.defaultValue"
						(ngModelChange)="onContentChange($event)"
						[name]="'variableSelector'"
						[options]="selectorOptions?.variables"
						[extendable]="true"
						theme="dark"
					></bb-entity-selector>

					<bb-entity-selector 
						*ngIf="!conditionVariable.rule.lvalue?.datasource"
						[(ngModel)]="conditionVariable.rule.lvalue"
						(ngModelChange)="onContentChange($event)"
						[name]="'variableSelector'"
						[options]="selectorOptions?.variables"
						[extendable]="true"
						theme="dark"
					></bb-entity-selector>
				</ie-form-field>
			</div>
			
			<div class="condition-row" *ngIf="currentType === 'boolean'">
				<bb-radio-list class="condition-row" [options]="radioOptions" [(ngModel)]="conditionVariable.rule.operator" (ngModelChange)="onContentChange($event)"></bb-radio-list>
			</div>

			<div class="condition-operator condition-row" *ngIf="currentType !== 'boolean'">
				<ie-form-field>
					<bb-select class="ie-form-field-styling" theme="dark" [options]="operatorList" [(ngModel)]="conditionVariable.rule.operator" (ngModelChange)="onContentChange($event)"></bb-select>
				</ie-form-field>
			</div>
			<div class="condition-right condition-row" *ngIf="currentType !== 'boolean'">
				<ie-form-field [label]="'VALUE' | translate" *ngIf="conditionVariable.entityType === 'localstorage' && (conditionVariable.rule.operator === '==' || conditionVariable.rule.operator === '!=')"
					[useDataSource]="true"
					(dataSourceClicked)="dataSourceService.onDataSourceClicked(conditionVariable.rule, dataSourceTemplate)"
					[dataSourceActive]="conditionVariable.rule.rvalue?.datasource"
				>
					<!-- todo: unique name -->
					<bb-entity-selector 
						*ngIf="conditionVariable.rule.rvalue?.datasource?.sourceType"
						[(ngModel)]="conditionVariable.rule.rvalue.datasource.defaultValue"
						(ngModelChange)="onContentChange($event)"
						[name]="'localstorageValueSelector'"
						[options]="selectorOptions?.localstorageValues"
						[extendable]="true"
						theme="dark"
					></bb-entity-selector>

					<bb-entity-selector 
						*ngIf="!conditionVariable.rule.rvalue?.datasource"
						[(ngModel)]="conditionVariable.rule.rvalue"
						(ngModelChange)="onContentChange($event)"
						[name]="'localstorageValueSelector'"
						[options]="selectorOptions?.localstorageValues"
						[extendable]="true"
						theme="dark"
					></bb-entity-selector>

				</ie-form-field>
				
				<ie-form-field
					*ngIf=" ! ( conditionVariable.entityType === 'localstorage' && (conditionVariable.rule.operator === '==' || conditionVariable.rule.operator === '!=') )"
					[label]="'VALUE' | translate"
					[useDataSource]="true"
					(dataSourceClicked)="dataSourceService.onDataSourceClicked(conditionVariable.rule, dataSourceTemplate)"
					[dataSourceActive]="conditionVariable.rule.rvalue?.datasource"
				>
						<!-- todo: unique name -->
					<input 
						*ngIf="conditionVariable.rule.rvalue?.datasource"
						[(ngModel)]="conditionVariable.rule.rvalue.datasource.defaultValue"
						(change)="onContentChange($event)"
						class="conditions-input ie-form-field-styling"
						name="condition-rvalue"
						[type]="(conditionVariable.rule.operator === '<' || conditionVariable.rule.operator === '>') ? 'number' : 'text'"
					/>
					<input 
						*ngIf="!conditionVariable.rule.rvalue?.datasource"
						[(ngModel)]="conditionVariable.rule.rvalue"
						(change)="onContentChange($event)"
						class="conditions-input ie-form-field-styling"
						name="condition-rvalue"
						[type]="(conditionVariable.rule.operator === '<' || conditionVariable.rule.operator === '>') ? 'number' : 'text'"
					/>
				</ie-form-field>
			</div>
		</ng-container>
	</div>
</div>

<ng-template #dataSourceTemplate>
	<bb-data-source-picker
		*ngIf="dataSourceService.dataSourceModel !== undefined"
		[model]="dataSourceService.dataSourceModel"
		[valueProperty]="'rvalue'"
		(ok)="dataSourceService.onDataSourceOk($event, 'rvalue'); onDataSourceChanged();"
		(remove)="dataSourceService.onDataSourceRemove($event, 'rvalue'); onDataSourceChanged();"
		(cancel)="dataSourceService.onDataSourceCancel($event)"
		(closed)="dataSourceService.onDataPickerClosed()"
	></bb-data-source-picker>
</ng-template>

<ng-template #dataSourceTemplateLValue>
	<bb-data-source-picker
		*ngIf="dataSourceService.dataSourceModel !== undefined"
		[model]="dataSourceService.dataSourceModel"
		[valueProperty]="'lvalue'"
		(ok)="dataSourceService.onDataSourceOk($event, 'lvalue'); onDataSourceChanged();"
		(remove)="dataSourceService.onDataSourceRemove($event, 'lvalue'); onDataSourceChanged();"
		(cancel)="dataSourceService.onDataSourceCancel($event)"
		(closed)="dataSourceService.onDataPickerClosed()"
	></bb-data-source-picker>
</ng-template>
